export const HIDDeviceUpgradeObj =
{
    //获取CRC
    getCRC(len,cmd,endData)
    {
        return 0x35 + 0x5c + len + cmd +  endData;
    },
    // 计算解锁签名
    blSignatureKey: [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476],
    blSignatureParams: [0x65237401, 0x73104256, 0xefab89cd, 0xba98dcfe],
    blSignatureUnlock: [0xaefdb8c9, 0xdc98feba, 0x63742501, 0x27615403],
    shift(x, n) {
        return ((x << n) | (x >>> (32 - n))) >>> 0;
    },

    FF(x, y, z) {
        return (((x) & (y)) | ((~x) & (z))) >>> 0;
    },

    GG(x, y, z) {
        return (((x) & (z)) | ((y) & (~z))) >>> 0;
    },

    HH(x, y, z) {
        return ((x) ^ (y) ^ (z)) >>> 0;
    },

    II(x, y, z) {
        return ((y) ^ ((x) | (~z))) >>> 0;
    },
    crc16(fw) 
    {
        let code = new Uint8Array(512);
        let wCRCin = 0x0000;
        let fw_size = fw.length;
        const block_size = 512;

        console.log(`CRC fw_size: ${fw_size} ${Math.floor(fw_size / 1024)}KB`);

        for (let pos = 0; pos < fw_size; pos += block_size) {
            let len = fw_size - pos;
            if (len > block_size) len = block_size;

            // 获取代码块（模拟 get_fw 函数的效果）
            code.set(fw.slice(pos, pos + len));

            // 计算 CRC
            wCRCin = this.crc16CCITTIteration(wCRCin, code, len);
        }

        return wCRCin;
    },

    crc16CCITTIteration(wCRCin, data, datalen) {
    const wCPoly = 0x8408;

    for (let i = 0; i < datalen; i++) {
        wCRCin ^= data[i];
            for (let j = 0; j < 8; j++) {
                if (wCRCin & 0x01) {
                    wCRCin = (wCRCin >> 1) ^ wCPoly;
                } else {
                    wCRCin = wCRCin >> 1;
                }
            }
        }

        return wCRCin;
    },
    byteConvert32Bit(datas) {
        return (datas[0] | (datas[1] << 8) | (datas[2] << 16) | (datas[3] << 24)) >>> 0;
    },

    convertByte(data) {
        return [
            (data & 0xFF),
            (data >> 8) & 0xFF,
            (data >> 16) & 0xFF,
            (data >> 24) & 0xFF
        ];
    },

    signatureIteration(v, k) {
        let v0 = v[0], v1 = v[1], sum = 0;
        const delta = 0x9e3779b9;
        for (let i = 0; i < 16; i++) {
            sum = (sum + delta) >>> 0;
            v0 = (v0 + (((v1 << 4) + k[0]) ^ (v1 + sum) ^ ((v1 >>> 5) + k[1]))) >>> 0;
            v1 = (v1 + (((v0 << 4) + k[2]) ^ (v0 + sum) ^ ((v0 >>> 5) + k[3]))) >>> 0;
        }
        v[0] = v0;
        v[1] = v1;

        return v;
    },

    blSignature(Datas, KEYS, params, unlock) {
        let datas = [];
        let keys = KEYS.slice(); // 复制密钥数组

        for (let i = 0; i < 4; i++) {
            datas[i] = this.byteConvert32Bit(Datas.slice(i * 4, (i + 1) * 4));
        }

        // console.log("datas", datas[0].toString(16).padStart(8, '0'), datas[1].toString(16).padStart(8, '0'),
        //     datas[2].toString(16).padStart(8, '0'), datas[3].toString(16).padStart(8, '0'))

        // 滚动迭代, 可以确保任意数据都能够影响所有输出
        var buf = [];
        buf = this.signatureIteration(datas.slice(0, 2), keys);
        datas[0] = buf[0]
        datas[1] = buf[1]

        buf = this.signatureIteration(datas.slice(1, 3), keys);
        datas[1] = buf[0]
        datas[2] = buf[1]

        buf = this.signatureIteration(datas.slice(2, 4), keys);
        datas[2] = buf[0]
        datas[3] = buf[1]

        datas[4] = datas[0];
        buf = this.signatureIteration(datas.slice(3, 5), keys);
        datas[3] = buf[0]
        datas[4] = buf[1]

        datas[0] = datas[4];

        // console.log("datas2:", datas[0].toString(16).padStart(8, '0'), datas[1].toString(16).padStart(8, '0'),
        //     datas[2].toString(16).padStart(8, '0'), datas[3].toString(16).padStart(8, '0'))

        // 更新秘钥
        // console.log("unlock:", unlock)
        // console.log("keys:", keys[0].toString(16).padStart(8, '0'), keys[1].toString(16).padStart(8, '0'),
        //     keys[2].toString(16).padStart(8, '0'), keys[3].toString(16).padStart(8, '0'))
        // console.log("params:", params[0].toString(16).padStart(8, '0'), params[1].toString(16).padStart(8, '0'),
        //     params[2].toString(16).padStart(8, '0'), params[3].toString(16).padStart(8, '0'))
        keys[0] = this.FF(keys[0], datas[0], params[0]) + unlock;
        keys[1] = this.GG(keys[1], datas[1], params[1]) + unlock;
        keys[2] = this.HH(keys[2], datas[2], params[2]) + unlock;
        keys[3] = this.II(keys[3], datas[3], params[3]) + unlock;

        // console.log("keys2:", keys[0].toString(16).padStart(8, '0'), keys[1].toString(16).padStart(8, '0'),
        //     keys[2].toString(16).padStart(8, '0'), keys[3].toString(16).padStart(8, '0'))

        // 第二次滚动迭代
        buf = this.signatureIteration(datas.slice(0, 2), keys);
        datas[0] = buf[0]
        datas[1] = buf[1]

        buf = this.signatureIteration(datas.slice(1, 3), keys);
        datas[1] = buf[0]
        datas[2] = buf[1]

        buf = this.signatureIteration(datas.slice(2, 4), keys);
        datas[2] = buf[0]
        datas[3] = buf[1]

        datas[4] = datas[0];
        buf = this.signatureIteration(datas.slice(3, 5), keys);
        datas[3] = buf[0]
        datas[4] = buf[1]

        datas[0] = datas[4];

        // console.log("datas3:", datas[0].toString(16).padStart(8, '0'), datas[1].toString(16).padStart(8, '0'),
        //     datas[2].toString(16).padStart(8, '0'), datas[3].toString(16).padStart(8, '0'))

        // 输出
        let SIGN = [];
        SIGN = SIGN.concat(this.convertByte(datas[0]));
        SIGN = SIGN.concat(this.convertByte(datas[1]));
        SIGN = SIGN.concat(this.convertByte(datas[2]));
        SIGN = SIGN.concat(this.convertByte(datas[3]));

        // console.log("SIGN:", SIGN[0].toString(16).padStart(8, '0'), SIGN[1].toString(16).padStart(8, '0'),
        //     SIGN[2].toString(16).padStart(8, '0'), SIGN[3].toString(16).padStart(8, '0'))

        return SIGN;
    },
    toHexStringArr(bytes) 
    {
        var str = bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');

        return str.match(/.{1,2}/g);
    },
    mergeUint8Arrays(arrays) 
    {
      // 计算总长度
      let totalLength = arrays.reduce((acc, arr) => acc + arr.length, 0);
      // 创建一个新的Uint8Array
      let result = new Uint8Array(totalLength);
      let offset = 0;
      
      arrays.forEach(arr => {
          result.set(arr, offset);
          offset += arr.length;
      });
      
      return result;
    },
    fromHexString(hexString) 
    {
        return new Uint8Array(hexString.toString().match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
    },
    padTo512(firmwareBuffer)
    {
        let length = firmwareBuffer.length;
        let paddedLength = Math.ceil(length / 512) * 512;

        let result = new Uint8Array(paddedLength);
 
        // 复制原始数据到新数组
        result.set(firmwareBuffer);
     
        // 用0xFF填充剩余部分
        for (let i = length; i < paddedLength; i++) 
        {
            result[i] = 0xFF;
        }
     
        return result;
    },
    padToPackage254(packageBuffer)
    {
        let length = packageBuffer.length;
        let paddedLength = Math.ceil(length / 254) * 254;

        let result = new Uint8Array(paddedLength);
 
        // 复制原始数据到新数组
        result.set(packageBuffer);
     
        // 用0xFF填充剩余部分
        for (let i = length; i < paddedLength; i++) 
        {
            result[i] = 0xFF;
        }
     
        return result;
    },
    getHighLowBits(decimal) 
    {
        if (decimal >= 0 && decimal <= 65535) 
        {
            let val = [decimal & 255,decimal >> 8];// 低位在前，高位在后
            val[0] = val[0].toString(16);
            val[1] = val[1].toString(16);

            return  val;

        } 
        else {
            throw new Error('The decimal number must be between 0 and 65535.');
        }
    },
    getHighLowBits32(decimal) 
    {
        // 提取高四位
        let highFourBits =  (decimal & 0xFFFF0000) >> 16;
        // 提取低四位
        let lowFourBits = (decimal & 0x0000FFFF);

        if (decimal >= 0 && decimal <= 4294967295) 
        {
            let val = [lowFourBits & 255,lowFourBits >> 8,highFourBits & 255,highFourBits >> 8];// 低位在前，高位在后
            val[0] = val[0].toString(16);
            val[1] = val[1].toString(16);
            val[2] = val[2].toString(16);
            val[3] = val[3].toString(16);

            return  val;
        } 
        else {
            throw new Error('The decimal number must be between 0 and 65535.');
        }

    },
    unpack(commandgroup)
    {
        let packagesCommand = [];
        for(let i=0;i < commandgroup.length;i++)
        {
            let packages = [];
            let itemPack = commandgroup[i];

            packages[0] = commandgroup[i].slice(0*64,64*1);
            packages[1] = commandgroup[i].slice(1*64,64*2);
            packages[2] = commandgroup[i].slice(2*64,64*3);
            packages[3] = commandgroup[i].slice(3*64,64*4);


            packagesCommand.push(packages);
        }
        return packagesCommand;
    },
    getFirmwareBufferCommand(firmwareBuffer,cmd10)
    {
        let commandHead     = new Uint8Array(cmd10.SET_DEVICE_WRITE_FIRMWARE_CMD.map(hex => parseInt(hex, 16)));
        let commandgroup    = [];
        let addrCur = 0;

        let paddedLength = Math.ceil(firmwareBuffer.length / 244);
        for(let i=0;i < paddedLength;i++)
        {
            let start = i*244;
            let end = (i+1)*244;
                end = end > firmwareBuffer.length?firmwareBuffer.length:end;
            let itemDatas = firmwareBuffer.slice(start,end);
            let countPackage  = this.mergeUint8Arrays([commandHead,itemDatas]);

            //数据实际长度
            let dataLen = this.getHighLowBits(itemDatas.length);
            countPackage[8] = parseInt(dataLen[0], 16);
            countPackage[9] = parseInt(dataLen[1], 16);

            //地址偏移
            let addr32Bits = this.getHighLowBits32(addrCur);
            countPackage[4] = parseInt(addr32Bits[0],16);
            countPackage[5] = parseInt(addr32Bits[1],16);
            countPackage[6] = parseInt(addr32Bits[2],16);
            countPackage[7] = parseInt(addr32Bits[3],16);
                
            //CRC
            let endData = countPackage[countPackage.length-1];
                countPackage[3] = this.getCRC(commandHead[1],commandHead[2],endData);

            //对齐数据
            if(end == firmwareBuffer.length)
            {
                countPackage =  this.padToPackage254(countPackage);
            }
            commandgroup.push(countPackage);

            //地址偏移
            addrCur += itemDatas.length;
        }

        return this.unpack(commandgroup);
    },
    getFirmwareBufferLenCommand(len,cmd10)
    {
        let commandHead     = new Uint8Array(cmd10.SET_DEVICE_SIGN_ERASE_CMD.map(hex => parseInt(hex, 16)));

        //擦除长度
        let addr32Bits = this.getHighLowBits32(len);
            commandHead[8] = parseInt(addr32Bits[0],16);
            commandHead[9] = parseInt(addr32Bits[1],16);
            commandHead[10] = parseInt(addr32Bits[2],16);
            commandHead[11] = parseInt(addr32Bits[3],16);

        return commandHead;
    },
    getFirmwareCRCCommand(len,cmd10)
    {
        let commandHead     = new Uint8Array(cmd10.READ_DEVICE_APP_CRC_CMD.map(hex => parseInt(hex, 16)));

        //CRC
        let endData = commandHead[commandHead.length-1];
            commandHead[3] = this.getCRC(commandHead[1],commandHead[2],endData);

        //擦除长度
        let addr32Bits = this.getHighLowBits32(len);
            commandHead[8] = parseInt(addr32Bits[0],16);
            commandHead[9] = parseInt(addr32Bits[1],16);
            commandHead[10] = parseInt(addr32Bits[2],16);
            commandHead[11] = parseInt(addr32Bits[3],16);

        return commandHead;
    },
    getFirmwareToAppCommand(len,SignCRC,cmd10)
    {
        let commandHead     = new Uint8Array(cmd10.SET_DEVICE_SIGN_APP_CMD.map(hex => parseInt(hex, 16)));


        //擦除长度
        let addr32Bits = this.getHighLowBits32(len);
            commandHead[8] = parseInt(addr32Bits[0],16);
            commandHead[9] = parseInt(addr32Bits[1],16);
            commandHead[10] = parseInt(addr32Bits[2],16);
            commandHead[11] = parseInt(addr32Bits[3],16);

            commandHead[12] = SignCRC[0];
            commandHead[13] = SignCRC[1];

        //CRC
        let endData = commandHead[commandHead.length-1];
            commandHead[3] = this.getCRC(commandHead[1],commandHead[2],endData);

        return commandHead;
    }
}
